import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const LightBulbIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M10.0009 13C10.0009 14.1046 9.10545 15 8.00088 15C6.89631 15 6.00088 14.1046 6.00088 13H10.0009ZM7.98818 1C10.7678 1 13.0211 3.25333 13.0211 6.03295C13.0211 7.27824 12.5595 8.4793 11.7254 9.40393L10.4746 10.7906C10.1754 11.1223 10.0097 11.5532 10.0097 12H6.01351C6.01351 11.5388 5.8448 11.0934 5.53918 10.748L4.25221 9.2932C2.42682 7.22989 2.61974 4.07748 4.68308 2.25212C5.59504 1.44535 6.77059 1 7.98818 1Z"
		/>
	</svg>
))
